import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export interface SocialCausesData {
  causes: {
    ids: string[];
    pt: string[];
    en: string[];
    da: string[];
    de: string[];
    es: string[];
    fr: string[];
    it: string[];
    ko: string[];
    nl: string[];
    pl: string[];
  };
  maxCauses: number;
}

@Injectable({
  providedIn: 'root'
})
export class SocialCausesService {
  private socialCausesData: SocialCausesData = {
    causes: {
      ids: [
        "sustainability",
        "antifascism",
        "humanrights",
        "nonprofits",
        "feminism",
        "LGBTQIA",
        "landreform",
        "antiracism",
        "mentalhealth",
        "veganism",
        "guncontrol",
        "immigrantrights"
      ],
      pt: [
        "🌍 Sustentabilidade",
        "✊ Antifascismo",
        "🤝 Direitos Humanos",
        "🏫 Apoio a ONGs",
        "🚺 Feminismo",
        "🏳️‍🌈 Apoio à comunidade LGBTQIA+",
        "🌾 Reforma Agrária",
        "✊🏿 Antirracismo",
        "🧠 Saúde Mental",
        "🌱 Veganismo",
        "🚫 Controle de Armas",
        "✈️ Direitos dos Imigrantes"
      ],
      en: [
        "🌱 Sustainability",
        "✊ Anti-Fascism",
        "🤝 Human Rights",
        "🏫 Support for Nonprofits",
        "🚺 Feminism",
        "🏳️‍🌈 LGBTQIA+ Ally",
        "🌾 Land Reform",
        "✊🏿 Anti-Racism",
        "🧠 Mental Health Advocacy",
        "🌿 Veganism",
        "🚫 Gun Control",
        "🌍 Immigrant Rights"
      ],
      da: [
        "🌱 Bæredygtighed",
        "✊ Antifascisme",
        "🤝 Menneskerettigheder",
        "🏫 Støtte til NGO'er",
        "🚺 Feminisme",
        "🏳️‍🌈 Støtte til LGBTQIA+ samfundet",
        "🌾 Landbrugsreform",
        "✊🏿 Antiracisme",
        "🧠 Mentalt helbred",
        "🌿 Veganisme",
        "🚫 Våbenkontrol",
        "🌍 Immigrantrettigheder"
      ],
      de: [
        "🌱 Nachhaltigkeit",
        "✊ Antifaschismus",
        "🤝 Menschenrechte",
        "🏫 Unterstützung von NGOs",
        "🚺 Feminismus",
        "🏳️‍🌈 Unterstützung für die LGBTQIA+-Gemeinschaft",
        "🌾 Agrarreform",
        "✊🏿 Antirassismus",
        "🧠 Psychische Gesundheit",
        "🌿 Veganismus",
        "🚫 Waffenkontrolle",
        "🌍 Immigrantenrechte"
      ],
      es: [
        "🌱 Sostenibilidad",
        "✊ Antifascismo",
        "🤝 Derechos Humanos",
        "🏫 Apoyo a las ONGs",
        "🚺 Feminismo",
        "🏳️‍🌈 Aliado de la comunidad LGBTQIA+",
        "🌾 Reforma Agraria",
        "✊🏿 Antirracismo",
        "🧠 Salud Mental",
        "🌿 Veganismo",
        "🚫 Control de Armas",
        "🌍 Derechos de los Inmigrantes"
      ],
      fr: [
        "🌱 Sustainabilité",
        "✊ Antifascisme",
        "🤝 Droits Humains",
        "🏫 Soutien aux ONG",
        "🚺 Féminisme",
        "🏳️‍🌈 Soutien à la communauté LGBTQIA+",
        "🌾 Réforme Agraire",
        "✊🏿 Antiracisme",
        "🧠 Santé Mentale",
        "🌿 Véganisme",
        "🚫 Contrôle des armes à feu",
        "🌍 Droits des Immigrés"
      ],
      it: [
        "🌱 Sostenibilità",
        "✊ Antifascismo",
        "🤝 Diritti Umani",
        "🏫 Sostegno alle ONG",
        "🚺 Femminismo",
        "🏳️‍🌈 Sostegno alla comunità LGBTQIA+",
        "🌾 Riforma Agraria",
        "✊🏿 Antirazzismo",
        "🧠 Salute Mentale",
        "🌿 Veganismo",
        "🚫 Controllo delle Armi",
        "🌍 Diritti degli Immigrati"
      ],
      ko: [
        "🌱 지속 가능성",
        "✊ 반파시즘",
        "🤝 인권",
        "🏫 비정부기구(NGO) 지원",
        "🚺 페미니즘",
        "🏳️‍🌈 LGBTQIA+ 커뮤니티 지원",
        "🌾 농지 개혁",
        "✊🏿 반인종주의",
        "🧠 정신 건강",
        "🌿 비건주의",
        "🚫 총기 규제",
        "🌍 이민자 권리"
      ],
      nl: [
        "🌱 Duurzaamheid",
        "✊ Antifascisme",
        "🤝 Mensenrechten",
        "🏫 Steun voor NGO’s",
        "🚺 Feminisme",
        "🏳️‍🌈 LGBTQIA+ bondgenoot",
        "🌾 Landhervorming",
        "✊🏿 Antiracisme",
        "🧠 Geestelijke gezondheid",
        "🌿 Veganisme",
        "🚫 Wapencontrole",
        "🌍 Rechten van immigranten"
      ],
      pl: [
        "🌱 Zrównoważony rozwój",
        "✊ Antyfaszyzm",
        "🤝 Prawa człowieka",
        "🏫 Wsparcie dla organizacji pozarządowych",
        "🚺 Feminizm",
        "🏳️‍🌈 Wsparcie dla społeczności LGBTQIA+",
        "🌾 Reformy rolnictwa",
        "✊🏿 Zwalczanie rasizmu",
        "🧠 Zdrowie psychiczne",
        "🌿 Weganizm",
        "🚫 Kontrola dostępu do broni",
        "🌍 Prawa imigrantów"
      ],
    },
    maxCauses: 3
  };

  constructor(private translate: TranslateService) { }

  getSocialCauseDisplayText(causeId: string): string {
    const index = this.socialCausesData.causes.ids.indexOf(causeId);
    if (index === -1) {
      return causeId; // Fallback to the ID if not found
    }

    const preferredLangs: string[] = [];
    if (this.translate.currentLang) preferredLangs.push(this.translate.currentLang);
    if (this.translate.getBrowserLang()) preferredLangs.push(this.translate.getBrowserLang() as string);
    preferredLangs.push('en', 'pt');

    for (const lang of preferredLangs) {
      const texts = (this.socialCausesData.causes as any)[lang] as string[] | undefined;
      if (texts && texts[index]) {
        return texts[index];
      }
    }
    return causeId;
  }

  getSocialCausesData(): SocialCausesData {
    return this.socialCausesData;
  }

  getCausesForLanguage(language: string): { id: string; text: string }[] {
    const candidates = [language, this.translate.currentLang, this.translate.getBrowserLang(), 'en', 'pt'].filter(Boolean) as string[];
    let texts: string[] | undefined;
    for (const lang of candidates) {
      const arr = (this.socialCausesData.causes as any)[lang] as string[] | undefined;
      if (arr) { texts = arr; break; }
    }
    if (!texts) {
      texts = this.socialCausesData.causes.en;
    }
    return this.socialCausesData.causes.ids.map((id, index) => ({ id, text: texts![index] || id }));
  }
}

